import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col} from 'react-bootstrap'
import {infoStatus} from '../../core/redux/status'
import DashboardPanelAdd from '../../core/components/DashboardPanelAdd'
import AverageNoteDashboardPanel from '../../satisfaction/components/AverageNoteDashboardPanel'
import i18n from '../i18n'
import ProviderDashboardPanel from './ProviderDashboardPanel'
import AgencyDashboardPanel from './AgencyDashboardPanel'
import CallPurposeDashboardPanel from './CallPurposeDashboardPanel'
import ClosingRateDashboardPanel from './ClosingRateDashboardPanel'
import PatrimonyDashboardPanel from './PatrimonyDashboardPanel'

class TicketDashboard extends Component {
    static propTypes = {
    }

    render() {
        const {dispatch} = this.props

        const panelHeader = (title) => (
            <h4>{title}</h4>
        )

        return (
            <Row>
                <Col sm={6} md={4}>
                    <AgencyDashboardPanel />
                    <PatrimonyDashboardPanel size='large' />
                </Col>
                <Col sm={6} md={4}>
                    <AverageNoteDashboardPanel
                        header={panelHeader(i18n.satisfaction)} />
                    <ProviderDashboardPanel size='large' />
                </Col>

                <Col sm={6} md={4}>
                    <ClosingRateDashboardPanel />
                    <CallPurposeDashboardPanel size='large' />
                </Col>
            </Row>
        )
    }
}

TicketDashboard = connect()(TicketDashboard)

export default TicketDashboard


// WEBPACK FOOTER //
// ./lib/ticket/components/TicketDashboard.js